import { render, staticRenderFns } from "./PostsSection.vue?vue&type=template&id=bfc9643e&"
import script from "./PostsSection.vue?vue&type=script&lang=js&"
export * from "./PostsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\marci\\Desktop\\majorel-china-static\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc9643e')) {
      api.createRecord('bfc9643e', component.options)
    } else {
      api.reload('bfc9643e', component.options)
    }
    module.hot.accept("./PostsSection.vue?vue&type=template&id=bfc9643e&", function () {
      api.rerender('bfc9643e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/templates/PostsSection.vue"
export default component.exports